// Libraries
import { Flex, Link, List, ListItem, Text } from '@chakra-ui/react';
import NextLink from 'next/link';
// Components
import { SidebarLink } from '@atoms/index';
// Types
import { SidebarSectionProps } from './SidebarSection.type';

/**
 * Represents a section of the sidebar containing a title and a list of links.
 *
 * @component
 * @param {SidebarSectionProps} props - The props for the SidebarSection component.
 * @param {SectionConfig} props.config - The configuration object for the sidebar section.
 * @param {string} props.currentPath - The current path that is being displayed.
 * @param {Function} props.onClose - Function for close the sidebar
 * @returns {ReactElement} The SidebarSection component.
 */
export const SidebarSection = ({ currentPath, config, onClose }: SidebarSectionProps) => {
  const { id, title, links } = config;

  return (
    <Flex as='section' id={id} py={4} borderBottom='section' direction='column' data-sidebar-section={id}>
      {title && (
        <Text
          mb={2.5}
          px={5}
          fontSize='xs'
          variant='faded'
          fontWeight='medium'
          textTransform='uppercase'
          textAlign='left'
        >
          {title}
        </Text>
      )}
      <List color='white'>
        {links.map((link) => (
          <ListItem key={link.url} onClick={onClose}>
            <NextLink href={link.url} passHref legacyBehavior>
              <Link display='block' variant='sidebar'>
                <SidebarLink text={link.text} isActive={link.url === currentPath} icon={link.icon} />
              </Link>
            </NextLink>
          </ListItem>
        ))}
      </List>
    </Flex>
  );
};
